__turbopack_context__.v({
  "messageBox": "GiftCardForm-module-scss-module__1TmX5G__messageBox",
  "messageHelperText": "GiftCardForm-module-scss-module__1TmX5G__messageHelperText",
});
